import { createContext, useContext } from "react";

export type NotificationKind = "success" | "error" | "info";

export interface NotificationItem {
  id: string;
  kind: NotificationKind;
  message: string;
}

export interface Notifications {
  notifyError: (message: string) => string;
  notifySuccess: (message: string) => string;
  notifyInfo: (message: string) => string;
  dismissNotification: (id: string) => void;
}

export const NotificationContext = createContext<Notifications | null>(null);

export function useNotifications(): Notifications {
  const notifications = useContext(NotificationContext);
  if (!notifications) {
    throw new Error("useNotifications must be used within NotificationProvider");
  }
  return notifications;
}
